import React from 'react';
import LayoutCustomerSuccess from 'src/components/LayoutCustomerSuccess/LayoutCustomerSuccess';
import NotificationIndex from 'src/components/Notifications';

const NotificationManagerPage = () => (
    <LayoutCustomerSuccess title="NOTIFICATIONS MANAGER">
        <NotificationIndex />
    </LayoutCustomerSuccess>
);

export default NotificationManagerPage;
